export default "__VITE_ASSET__DNzwPkCi__"